// Génération de la réponse -- /app/email/reply répond directement {"reply": "..."}.
import { getPraetoriaApiToken, PRAETORIA_API_BASE_URL } from "../config";
import { buildApiError, PraetoriaCancelledError, PraetoriaTimeoutError } from "./errors";
import { ExtractedAttachment, ReplyThreadMessage } from "./types";

const REQUEST_TIMEOUT_MS = 600000;
const SLOW_RESPONSE_MS = 15000;

export async function generateReply(
  subject: string,
  thread: ReplyThreadMessage[],
  consignePerso: string,
  previousReply: string,
  attachments: ExtractedAttachment[],
  graphToken: string,
  onSlowResponse?: () => void,
  externalSignal?: AbortSignal
): Promise<string> {
  const token = getPraetoriaApiToken();
  if (!token) {
    throw new Error("Token API Praetoria manquant (PRAETORIA_API_TOKEN).");
  }

  const controller = new AbortController();
  if (externalSignal) {
    externalSignal.addEventListener("abort", () => controller.abort());
  }
  const timeoutId = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);
  const slowResponseId = onSlowResponse ? setTimeout(onSlowResponse, SLOW_RESPONSE_MS) : undefined;

  let response: Response;
  try {
    response = await fetch(`${PRAETORIA_API_BASE_URL}/app/email/reply`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        subject,
        thread,
        consigne_perso: consignePerso,
        previous_reply: previousReply || null,
        attachments: attachments.filter((attachment) => attachment.text),
        graph_access_token: graphToken,
      }),
      signal: controller.signal,
    });
  } catch (error) {
    if (error instanceof Error && error.name === "AbortError") {
      if (externalSignal?.aborted) {
        throw new PraetoriaCancelledError();
      }
      throw new PraetoriaTimeoutError();
    }
    throw error;
  } finally {
    clearTimeout(timeoutId);
    clearTimeout(slowResponseId);
  }

  if (!response.ok) {
    throw await buildApiError(response);
  }

  const data = await response.json();
  return data.reply;
}
